import { NgModule } from '@angular/core';

import { TranslatePipe } from './translate/translate.pipe';
import { IbexDatePipe } from './ibex-date/ibex-date.pipe';
import { RoundPipe } from './round/round.pipe';
import { FormatTeaserPipe } from './formatTeaser/formatTeaser.pipe';
import { HyphenPipe } from './hyphen/hyphen';

@NgModule({
  declarations: [
    TranslatePipe,
    IbexDatePipe,
    RoundPipe,
    FormatTeaserPipe,
    HyphenPipe
  ],
  exports: [
    TranslatePipe,
    IbexDatePipe,
    RoundPipe,
    FormatTeaserPipe,
    HyphenPipe
  ]
})
export class PipesModule {
}
